import React from 'react';
import { ITaggedView } from '../../app/@types/searchBox';
import {
  SearchBoxContainer,
  TagList,
} from '../../app/common/sharedComponents/TaggedsView/styled.TaggedsView';
import { Tags } from '../../app/common/sharedComponents/Tags';

export function AssignedView ({ selectedOptions }: ITaggedView) {
  return (
    <SearchBoxContainer>
      <TagList>
        {selectedOptions.map((tag) => (
          <Tags key={tag.id} text={tag.text} disabled={true} />
        ))}
      </TagList>
    </SearchBoxContainer>
  );
}
